import React from 'react'
import { useState } from 'react'
import {
    Switch,
    Route,
    Link, useLocation, Redirect
  } from 'react-router-dom'

const TopNav = () => {
  const [burgerShow, setBurgerShow] = useState(false);

  const toggleBurgerNav = () => {
    if (burgerShow) {
      setBurgerShow(false)
    } else {
      setBurgerShow(true)
    }
  }
  
    return (
      <div className="top-nav-wrap">
         <nav id="top-nav" className={`top-nav hamburger-nav` + (burgerShow ? " show" : " hide")}>
            <Link className="button" to='/'><h3>Home</h3></Link>
            {/* <Link className="button"  to='/mybookings'><h3>My bookings</h3></Link> */}
            <Link className="button"  to='/BookTrip'><h3>Book travel</h3></Link>
            <Link className="button" to='/about'><h3>About</h3></Link>
            </nav>
            <button onClick={toggleBurgerNav } className={`hamburger-button` + (burgerShow ? " opened" : " closed")}><span>I</span><span>I</span><span>I</span></button>
      </div>
    )
}

export default TopNav